var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cog-payment__field" },
    [
      !_vm.overrideInputStyles
        ? _c("c-input", {
            ref: "paymentStyle",
            staticStyle: { display: "none" },
            attrs: { inputmode: "numeric", placeholder: "placeholder" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default", null, {
        inputStyles: _vm.inputStyles,
        saveCard: _vm.saveCard
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "cog-error-message" } }, [
        _vm.errorMessage
          ? _c(
              "div",
              {
                staticClass: "cog-form-payment-error cog-error-message",
                attrs: { "aria-live": "assertive", role: "alert" }
              },
              [
                _vm._v("\n\t\t\t" + _vm._s(_vm.errorMessage) + "\n\t\t\t"),
                _vm.supportPageLinkUrl
                  ? _c(
                      "a",
                      {
                        staticClass: "matins",
                        attrs: {
                          href: _vm.supportPageLinkUrl,
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.supportPageLinkText ||
                                "Learn how to fix this."
                            ) +
                            "\n\t\t\t"
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.saveCard
        ? _c("c-field", {
            staticClass: "cog-payment__save-card",
            attrs: { source: "Save_Card_Agreement", "hide-label": "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function({ field }) {
                    return [
                      _c("c-checkbox", {
                        attrs: {
                          label: _vm.$resource("card-on-file-agreement", {
                            orgname: _vm.session.organizationName
                          }),
                          "described-by": _vm.cardOwnerNotice
                            ? _vm.cardOwnerNoticeId
                            : null
                        },
                        model: {
                          value: field.value,
                          callback: function($$v) {
                            _vm.$set(field, "value", $$v)
                          },
                          expression: "field.value"
                        }
                      })
                    ]
                  }
                }
              ],
              null,
              false,
              4799119
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cardOwnerNotice
        ? _c(
            "div",
            {
              staticClass: "cog-payment__card-owner-notice cog-warning-message",
              attrs: { id: _vm.cardOwnerNoticeId }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.cardOwnerNotice) + "\n\t")]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }